import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom'
import ScrollToTop from './components/Shared/GenericComponents/ScrollToTop';
import { CustomProvider } from 'rsuite';
import enUS from 'date-fns/locale/en-US';

//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
const DateTimeFormats = {
    sunday: 'Su',
    monday: 'Mo',
    tuesday: 'Tu',
    wednesday: 'We',
    thursday: 'Th',
    friday: 'Fr',
    saturday: 'Sa',
    ok: 'OK',
    today: 'Today',
    yesterday: 'Yesterday',
    now: 'Now',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    /**
     * Format of the string is based on Unicode Technical Standard #35:
     * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
     **/
    formattedMonthPattern: 'MMM yyyy',
    formattedDayPattern: 'dd MMM yyyy',
    shortDateFormat: 'MM/dd/yyyy',
    shortTimeFormat: 'HH:mm',
    dateLocale: enUS
};
const Combobox = {
    noResultsText: 'No results found',
    placeholder: 'Select',
    searchPlaceholder: 'Search',
    checkAll: 'All'
};

const CreatableComboBox = {
    ...Combobox,
    newItem: 'New item',
    createOption: 'Create option "{0}"'
};

const locale = {
    code: 'en-US',
    common: {
        loading: 'Loading...',
        emptyMessage: 'No data found',
        remove: 'Remove',
        clear: 'Clear'
    },
    Plaintext: {
        unfilled: '',
        notSelected: '',
        notUploaded: ''
    },
    Pagination: {
        more: 'More',
        prev: 'Previous',
        next: 'Next',
        first: 'First',
        last: 'Last',
        limit: '{0} / page',
        total: 'Total Rows: {0}',
        skip: 'Go to{0}'
    },
    DateTimeFormats,
    Calendar: DateTimeFormats,
    DatePicker: DateTimeFormats,
    DateRangePicker: {
        ...DateTimeFormats,
        last7Days: 'Last 7 Days'
    },
    Combobox,
    InputPicker: CreatableComboBox,
    TagPicker: CreatableComboBox,
    Uploader: {
        inited: 'Initial',
        progress: 'Uploading',
        error: 'Error',
        complete: 'Finished',
        emptyFile: 'Empty',
        upload: 'Upload',
        removeFile: 'Remove file'
    },
    CloseButton: {
        closeLabel: 'Close'
    },
    Breadcrumb: {
        expandText: 'Show path'
    },
    Toggle: {
        on: 'Open',
        off: 'Close'
    }
};

root.render(
    <BrowserRouter>
        <React.StrictMode >
            <ScrollToTop />
            <CustomProvider locale={locale}>
                <App />
            </CustomProvider>
        </React.StrictMode>
    </BrowserRouter>
);

registerServiceWorker();

